'use strict';

import videoPlayerTemplate from './videoPlayer.html';

export const videoPlayerDirName = 'videoPlayer';
export function videoPlayerDir() {
  return {
    restrict: 'E', 
    template: videoPlayerTemplate,
    scope: {
      config: '='
    }
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/videoPlayer/videoPlayer.js